import styled from '@emotion/styled';

const PROGRESS_ICON_THRESHOLD = 0.5;

export const ReviewSection = styled.span<{ readonly color?: string; readonly progress?: number }>(
    ({ color, progress, theme }) => ({
        '[data-is-active="true"] &': {
            'svg circle:first-of-type': {
                stroke: theme.colors.orange[200],
            },
            'svg circle:last-of-type': {
                stroke: theme.colors.white[200],
            },
            'svg path': {
                fill:
                    progress !== undefined && progress > PROGRESS_ICON_THRESHOLD
                        ? theme.colors.white[200]
                        : theme.colors.orange[200],
            },
        },
        alignItems: 'center',
        color,
        display: 'flex',
        fontSize: theme.typography.body.XXS.semibold.fontSize,
        fontWeight: theme.typography.body.XXS.semibold.fontWeight,
        gap: theme.spacing.xxs,
    }),
);
